/* eslint-disable import/prefer-default-export */
import GTM from '@/utils/Controllers/GTM/Constants';
import { push } from '@/utils/Controllers/GTM/Utils';

export const pushGtmProductZoom = () => {
  push({
    event: GTM.EVENT.PRODUCT_ZOOM,
  });
};
